import React from "react";

import { StudentApi, studentsApi } from "api/studentsApi";
import { useToaster } from "utils";
import { PaziaButton } from "components/atoms";
import { PaziaModal } from "components/molecules";

interface ArchiveUserModalProps {
  onCloseRequest: () => void;
  user: StudentApi | null;
  onSuccessArchive?: () => void;
}

export const ArchiveUserModal = ({ onCloseRequest, onSuccessArchive, user }: ArchiveUserModalProps) => {
  const { showError, showSuccess } = useToaster();

  const archiveUser = async () => {
    try {
      await studentsApi.delete(user!.id);
      onCloseRequest();
      // onSuccessArchive(); TODO
      showSuccess("Użytkownik został zarchiwizowany");
    } catch {
      showError("Nie udało się zarchiwizować użytkownika");
    }
  };

  return (
    <PaziaModal id="craete-topic-modal" onCloseRequest={onCloseRequest} isOpen={user != null}>
      {user && (
        <div className="flex flex-col gap-4 px-5 pt-4 pb-6">
          <div className="text-xl">
            <span className="font-medium text-slate-800 dark:text-slate-100 mb-2">
              Archiwizowanie użytkownika {user.firstName} {user.surname}
            </span>
          </div>
          <PaziaButton type="success" title="Zatwierdź" onClick={archiveUser} />
        </div>
      )}
    </PaziaModal>
  );
};
